import { goWechat } from '@/utils';
import { useEffect, useRef } from 'react';
import './index.scss';

interface initProps {
  title?: string; // 标题
  info?: any;
  imgChild: any; //图片
  clicButton?: any;
}
const BaseModal = (props: initProps) => {
  const { info, imgChild, clicButton } = props;
  const btnBoxRef: any = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      goWechat(btnBoxRef);
    }, 500);
  }, [btnBoxRef]);
  return (
    <div className="error-index">
      <div className="img">{imgChild}</div>
      <span className="info">{info}</span>
      <div className="btn">
        <span ref={btnBoxRef} className="coin_overdueBtnH5" />
        {clicButton}
      </div>
    </div>
  );
};

export default BaseModal;
